import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleCliente } from "../hooks/roles/ProtectedRoleCliente";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const TareaDetalleCalificarFinalizar = React.lazy(
  () =>
    import(
      "../components/task/tareaDetalleCalificarFinalizar/tarea-detalle-calificar-finalizar"
    )
);
export function tareaDetalleCalificarFinalizar() {
  return (
    <Route
      path="/tarea-detalle-calificar-finalizar"
      element={
        <LazySuspense>
          <ProtectedRoute>
            <ProtectedRoleCliente>
              <LazySuspense>
                <TareaDetalleCalificarFinalizar />
              </LazySuspense>
            </ProtectedRoleCliente>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
